import { apiClient, idempotentConfig, unwrap } from './client';
import type {
  ApiEnvelope,
  DispositionAction,
  DispositionResult,
  ReviewItemDetail,
  ReviewQueue,
  ReviewStatus,
} from './types';

/**
 * Migration review queue (the 153 NEEDS_HUMAN_REVIEW flows) — PS-2 cross-track contract. Track A
 * builds these in parallel; the SPA degrades to a teaching empty state if they are not live yet.
 */

const enc = (s: string) => encodeURIComponent(s);

export interface ReviewQueueQuery {
  reason?: string;
  status?: ReviewStatus;
  page?: number;
  pageSize?: number;
}

/** GET /v1/migration/review-queue — the flagged flows, filterable by reason + status. */
export async function listReviewQueue(q: ReviewQueueQuery = {}): Promise<ReviewQueue> {
  const { data } = await apiClient.get<ApiEnvelope<ReviewQueue>>('/v1/migration/review-queue', {
    params: { reason: q.reason, status: q.status, page: q.page, pageSize: q.pageSize },
  });
  return unwrap(data);
}

/** GET /v1/migration/review-queue/{itemId} — item detail (diagnostics, source summary, IR preview). */
export async function getReviewItem(itemId: string): Promise<ReviewItemDetail> {
  const { data } = await apiClient.get<ApiEnvelope<ReviewItemDetail>>(
    `/v1/migration/review-queue/${enc(itemId)}`,
  );
  return unwrap(data);
}

/** POST /v1/migration/review-queue/{itemId}/disposition — accept / open-in-designer / archive. */
export async function dispositionReviewItem(
  itemId: string,
  action: DispositionAction,
  note?: string,
  idemKey?: string,
): Promise<DispositionResult> {
  const { data } = await apiClient.post<ApiEnvelope<DispositionResult>>(
    `/v1/migration/review-queue/${enc(itemId)}/disposition`,
    { action, note },
    idempotentConfig(idemKey),
  );
  return unwrap(data);
}
